export default __webpack_public_path__ + "static/media/image.content-analysis-tool.d3f3d844.png";